module.exports = __webpack_public_path__ + "static/media/mtn50.44d428a5.geojson";